import * as React from "react";
import * as _ from "lodash";

import {UserDto} from "../../../../services/Client";
import SelectField, {SelectedValue} from "../../../../components/SelectField";

export interface IRoleSelectionProps {
    /** Displayed when there's no role selected. */
    placeholder?: string;

    /** Data source array. All available roles. */
    users: UserDto[];

    /** Initially selected roles. */
    values?: UserDto[];

    /** Callback when the selected roles change. */
    onChange?: (users: UserDto[]) => any;

    readOnly?: boolean;

    searchable?: boolean;
}

/** Return the UserDto references from the group array that match values. */
export const selectUsers = (users: UserDto[], values: UserDto[]): UserDto[] => (
    users.filter(user => _.find(values, value => value.cn === user.cn) !== undefined)
);

export const UserSelection = (props: IRoleSelectionProps) => {
    const selectedValues = selectUsers(props.users, props.values || []);
    return (
        <SelectField
            placeholder={props.placeholder}
            disabled={props.readOnly}
            multi={true}
            searchable={props.searchable}
            clearable={false}
            dataSource={props.users}
            value={selectedValues}
            rendererKey={(user: UserDto) => `${user.cn} - ${user.name || ''} ${user.department ? `- (${user.department})`:''}`}
            rendererOption={(user: any) => {
                return <>{`${user.option.cn} - ${user.option.name || ''} ${user.option.department ? `(${user.option.department})`:''}`}</>;
            }}
            onChange={(selectedValue: Array<SelectedValue>) => {
                if (props.onChange) {
                    const users = selectedValue.map(value => value.selectedValue as UserDto);
                    props.onChange(users);
                }
            }}
        />
    );
};

export default UserSelection;


// WEBPACK FOOTER //
// ./src/views/AdminView/AccessTab/ProMTGroupsTab/UserSelection.tsx